import { render } from "./SupplierCreateInline.vue?vue&type=template&id=3a6f6098"
import script from "./SupplierCreateInline.vue?vue&type=script&lang=js"
export * from "./SupplierCreateInline.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__